var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout"},[_c('el-aside',{staticClass:"nav-left"},[_c('Steper',{attrs:{"data":_vm.steps,"current":_vm.current}})],1),_c('div',{staticClass:"main-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }